import React from 'react';
import { CircleNotch } from '@phosphor-icons/react';

export function LoadingSpinner({ size = 'md', className = '' }) {
  const sizes = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
  };

  return (
    <CircleNotch
      className={`animate-spin text-primary ${sizes[size]} ${className}`}
      weight="bold"
    />
  );
}

export function PageLoading() {
  return (
    <div className="flex items-center justify-center min-h-[400px]">
      <LoadingSpinner size="lg" />
    </div>
  );
}

export default LoadingSpinner;
